import { without } from 'underscore'
import * as yup from 'yup'

yup.addMethod(yup.object, 'atLeastOneRequired', function atLeastOneRequired(list, message) {
  // invariant(list.every(field => this.fields[field]), 'All required fields should be defined before calling atLeastOneRequired');
  // console.log(this.fields)
  return this.shape(
    list.reduce(
      (acc, field) => ({
        ...acc,
        [field]: this.fields[field].when(without(list, field), {
          is: (...values) => !values.some((item) => item),
          then: () => this.fields[field].required(message),
        }),
      }),
      {},
    ),
    list.reduce(
      (acc, item, idx, all) => [...acc, ...all.slice(idx + 1).map((i) => [item, i])],
      [],
    ),
  )
})
